<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title mb-0">{{title}}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="formBiometry">
      <div class="row">
        <div class="col-12">
          <div class="row col-12 justify-content-center">
            <div *ngIf="showSpinner" class="spinner-border text-primary" role="status">
            </div>
            <div class="row col-12 justify-content-center mt-3">
              {{messageStatus}}
            </div>
          </div>
          <div *ngIf="imageFingerPrint" class="d-flex justify-content-center mt-3">
            <img [src]="imageFingerPrint" width="150" class="img-thumbnail">
          </div>
        </div>
      </div>
      <div class="row d-none">
        <div class="col-md-12">
          <div class="form-group">
            <label for="nationalId" class="col-form-label">{{'@direction.pages.popupCredential.nationalId' | translate }}</label>
            <input type="text" class="form-control" id="nationalId" mask="000.000.000-00" formControlName="fir">
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="!imageFingerPrint" data-bs-dismiss="modal"
      (click)="onConfirm()">{{'@direction.pages.student.modalBiometry.buttonSend' | translate }}</button>
    <button type="button" class="btn btn-secondary" [disabled]="!showRenewFingerprint"
      (click)="renewFingerprint()">{{'@direction.pages.student.modalBiometry.buttonResend' | translate }}</button>
  </div>
</div>
